import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError  } from 'rxjs';
import { catchError, retry, share, shareReplay } from 'rxjs/operators';
import { CachingService } from './caching.service';
import { AuthService } from '../auth-service/auth.service';

/*
Generated class for the HttpServiceProvider provider.
*/
@Injectable()
export class HttpService {
	constructor(private http: HttpClient, private caching: CachingService, private auth: AuthService) {}

	/**
	 * Constructs a get request
	 * @param url
	 * @param key key for storing in cache
	 * @param ttl time to live in cache
	 * @return
	 */
	public get<T = any>(url: string, params?: HttpParams, key?: string, ttl?: number): Observable<T> {
		let observable;

		if (params != null) {
			let options = { params: params };
			observable = this.http.get<T>(url, options);
		} else {
			observable = this.http.get<T>(url);
		}

		observable.pipe(
			share(),
			retry(2),
		);

		// load from cache
		if (key != null) {
			return this.caching.loadFromCache(key, observable, ttl);
		}

		// no key then make direct network request
		return observable;
	}

	/**
	 * [description]
	 * @param url
	 * @param body
	 * @return
	 */
	public post<T = any>(url: string, body: any, options?: any) {
		// return this.http.post<T>(url, body, options).pipe(catchError(this.handleError));
		if (options != null) {
			return this.http.post<T>(url, body, options).pipe(catchError(this.handleError));
		}
		return this.http.post<T>(url, body).pipe(catchError(this.handleError));
	}

	/**
	 * [description]
	 * @param url
	 * @param body
	 * @return
	 */
	public put<T = any>(url: string, body: any): Observable<T> {
		return this.http.put<T>(url, body).pipe(catchError(this.handleError));
	}

	/**
	 * [description]
	 * @param url
	 * @param body
	 * @return
	 */
	public patch<T = any>(url: string, body: any): Observable<T> {
		return this.http.patch<T>(url, body).pipe(catchError(this.handleError));
	}

	/**
	 * [description]
	 * @param url
	 * @return
	 */
	public delete<T = any>(url: string): Observable<T> {
		return this.http.delete<T>(url).pipe(
			retry(2),
			catchError(this.handleError),
		);
	}

	private handleError(error: HttpErrorResponse): Observable<never> {
		if (error.error instanceof ErrorEvent) {
			// A client-side or network error occurred. Handle it accordingly.
			console.error('An error occurred:', error.error.message);
		} else {
			// The backend returned an unsuccessful response code.
			// The response body may contain clues as to what went wrong,
			console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
		}
		// return an ErrorObservable with a user-facing error message
		return observableThrowError('Something bad happened; please try again later.');
	}
}
